export enum FitLevel {
	STRONG = "STRONG",
	MEDIUM = "MEDIUM",
	WEAK = "WEAK",
	NO_FIT = "NO_FIT",
}
